// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"CreateShippingMethod_closeButton__1u_bd"};